import React, { Component } from 'react';
import css from '../ProjectPage/ProjectPage.module.scss';
import Header from '../ProjectPage/Header';
import ProjectItem from '../ProjectItem.js';

import ImgE1 from './assets/E1.png';
import ImgE2 from './assets/E2.png';
import ImgE3 from './assets/E3.jpg';
import ImgE4 from './assets/E4.jpg';
import ImgE5 from './assets/E5.jpg';
import ImgE6 from './assets/E6.png';

import ImgClimateDashboard from '../assets/ClimateDashboard.png';
import ImgUrbanMobility from '../assets/UrbanMobility.png';

export default class Twitch extends Component {

  render () {
      return (
        <div className={css.projectPage}>
          <Header
            title='Esports One Design System'
            year='2021'
            position='Freelance Product Designer'
          />
          <div className={css.content}>
            <img src={ImgE1} alt='Esports One Design System' />
            <div className={css.text}>
              <p>Fantasy esports platform, Esports One, is in the process of switching to Figma to scale up their design team’s capabilities. As an early stage startup, they’ve been focused on growth and moving quickly, but that’s lead to inconsistencies as new designs progress faster than the existing code base. They tasked me with performing a visual audit of their site’s components and Adobe XD files and creating a comprehensive design library in Figma which will function as a single source of truth for designers and developers going forward.</p>
              <p>After reviewing the existing designs, I split up the design system into four parts: brand assets and brand colours which could be shared with marketers and other teams, a UI kit, and an icon kit. </p>
            </div>
            <img src={ImgE2} alt='Design System File Setup' />
            <img src={ImgE3} alt='Brand Designs' />
            <img src={ImgE4} alt='Icon Library' />
            <img src={ImgE5} alt='Component Library' />
            <div className={css.text}>
              <p>Esports products consist mainly of tables so special attention was made to ensure they were highly customisable, resizable, and variants were developed for web and mobile.</p>
            </div>
            <img src={ImgE6} alt='Tables' />
          </div>
          <div className={css.moreWork}>
            <header>More Projects</header>
              <ul className={css.moreWorkList}>
                <ProjectItem
                  title='Climate Impact Dashboard'
                  description='B2B pivot for an Amsterdam-based green startup'
                  position='Freelance Product Manager & Designer'
                  img={ImgClimateDashboard}
                  link='ClimateDashboard'
                />
                <ProjectItem
                  title='Urban Mobility App'
                  description='EV ridesharing app and vehicle designs'
                  position='Freelance Product & Brand Designer'
                  img={ImgUrbanMobility}
                  link='UrbanMobility'
                />
              </ul>
          </div>
        </div>
      )
   }
}
